var InsuranceData = {
  product_id: 7298841280670,
  basic_variant: 41945179357342,
  threshold_price: 100,
  basic_price: 1.98,
  variants: [
    [1.98, 41945179357342],
    [2.42, 41945179390110],
    [2.53, 41945179422878],
    [2.65, 41945179455646],
    [2.76, 41945179488414],
    [2.88, 41945179521182],
    [2.99, 41945179553950],
    [3.11, 41945179586718],
    [3.22, 41945179619486],
    [3.34, 41945179652254],
    [3.45, 41945179685022],
    [3.57, 41945179717790],
    [3.68, 41945179750558],
    [3.80, 41945179783326],
    [3.91, 41945179816094],
    [4.03, 41945179848862],
    [4.14, 41945179881630],
    [4.26, 41945179914398],
    [4.37, 41945179947166],
    [4.49, 41945179979934],
    [4.60, 41945180012702],
    [4.78, 41945180045470],
    [4.97, 41945180078238],
    [5.15, 41945180111006],
    [5.34, 41945180143774],
    [5.52, 41945180176542],
    [5.70, 41945180209310],
    [5.89, 41945180242078],
    [6.07, 41945180274846],
    [6.26, 41945180307614],
    [6.44, 41945180340382],
    [6.62, 41945180373150],
    [6.81, 41945180405918],
    [7.08, 41945180438686],
    [7.36, 41945180471454],
    [7.64, 41945180504222],
    [7.91, 41945180536990],
    [8.19, 41945180569758],
    [8.46, 41945180602526],
    [8.74, 41945180635294],
    [9.02, 41945180668062],
    [9.48, 41945180700830],
    [9.94, 41945180733598],
    [10.40, 41945180766366],
    [10.86, 41945180799134],
    [11.32, 41945180831902],
    [12.01, 41945180864670],
    [12.70, 41945180897438],
    [13.39, 41945180930206],
    [14.08, 41945180962974],
    [14.77, 41945180995742],
    [15.46, 41945181028510],
    [16.15, 41945181061278],
    [16.84, 41945181094046],
    [17.53, 41945181126814],
    [18.22, 41945181159582],
    [18.91, 41945181192350],
    [19.60, 41945181225118],
    [20.29, 41945181290654],
    [20.98, 41945181323422],
    [21.67, 41945181356190],
    [22.36, 41945181421726],
    [23.05, 41945181454494],
    [25.35, 41945181487262],
    [27.65, 41945181520030],
    [29.95, 41945181552798],
    [32.25, 41945181618334],
    [34.55, 41945181651102],
    [36.85, 41945181683870],
    [39.15, 41945181716638],
    [41.45, 41945181749406],
    [43.75, 41945181782174],
    [46.05, 41945181814942],
    [55.25, 41945181847710],
    [59.85, 41945181880478],
    [64.45, 41945181913246],
    [69.05, 41945181946014],
    [78.25, 41945181978782],
    [87.45, 41945182011550],
    [96.65, 41945182044318],
    [105.85, 41945182077086],
    [115.05, 41945182109854],
    [126.55, 41945182142622],
    [138.05, 41945182175390],
    [149.55, 41945182208158],
    [161.05, 41945182240926],
    [172.55, 41945182273694],
    [184.05, 41945182306462],
    [195.55, 41945182339230],
    [207.05, 41945182371998],
    [218.55, 41945182404766]
  ].map(([price, id], index) => ({
    name: index === 0
      ? 'Basic Shipping Protection'
      : `A$${price.toFixed(2)}`,
    price: price.toFixed(2),
    id
  }))
};

(function () {
  if (window.EmraldLabsProtection?.version === '3.0.0') return;

  const root = window.Shopify?.routes?.root || '/';
  const storageKey = 'emrald.easyProtection.enabled.v3';
  const toggleSelector = '[id="easy-protection"]';
  const checkoutSelector = '#CartDrawer-Checkout, #checkout';

  const pendingUpdates = new Set();
  const ownedEvents = new WeakSet();
  const lockedControls = new Map();

  let enabled = readPreference();
  let lastCart = null;
  let checkingOut = false;
  let syncPromise = null;
  let syncRequested = false;
  let sectionsRequested = false;
  let mutationVersion = 0;
  let paintScheduled = false;

  const modulesReady = import('@shopify/events').then(api => {
    document.addEventListener(
      api.StandardEvents.cartLinesUpdate,
      handleCartUpdate
    );

    document.addEventListener(
      api.StandardEvents.cartDiscountUpdate,
      handleCartUpdate
    );

    return api;
  });

  modulesReady.catch(error => {
    console.error('[protection] Theme events unavailable:', error);
  });

  function getCookieValues(name) {
    const prefix = `${name}=`;

    return document.cookie
      .split(';')
      .map(part => part.trim())
      .filter(part => part.startsWith(prefix))
      .map(part => decodeURIComponent(part.slice(prefix.length)));
  }

  function readPreference() {
    try {
      const saved = localStorage.getItem(storageKey);

      if (saved === 'true' || saved === 'false') {
        return saved === 'true';
      }
    } catch {}

    const values = getCookieValues('Protectionstatus');

    if (values.includes('false')) return false;

    return values.includes('true');
  }

  function savePreference(value) {
    enabled = value === true;

    try {
      localStorage.setItem(storageKey, String(enabled));
    } catch {}

    document.cookie =
      `Protectionstatus=${enabled}; Path=/; SameSite=Lax`;

    paint();
  }

  function isProtection(item) {
    return (
      Number(item.product_id) === Number(InsuranceData.product_id) ||
      item.handle === 'easy-insurance'
    );
  }

  function regularItems(cart) {
    return cart.items.filter(item => !isProtection(item));
  }

  function closestVariant(total, variants = InsuranceData.variants) {
    const target = total * 2.3 / 100;

    return variants.reduce((previous, current) => {
      return Math.abs(Number(current.price) - target) <
        Math.abs(Number(previous.price) - target)
        ? current
        : previous;
    });
  }

  function quote(cart) {
    const items = regularItems(cart).filter(item => {
      return item.handle !== 'gift-card' && !item.gift_card;
    });

    const eligible = items.some(item => {
      return !item.properties?.['_free-product'];
    });

    const total = items.reduce((sum, item) => {
      return sum + item.final_line_price;
    }, 0) / 100;

    const variant = total > InsuranceData.threshold_price
      ? closestVariant(total)
      : {
          id: InsuranceData.basic_variant,
          price: InsuranceData.basic_price
        };

    return {
      eligible,
      variant,
      cents: eligible
        ? Math.round(Number(variant.price) * 100)
        : 0
    };
  }

  async function request(endpoint, payload) {
    const options = {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    };

    if (payload !== undefined) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }

    const response = await fetch(`${root}${endpoint}`, options);
    const data = await response.json();

    if (!response.ok || data.errors) {
      throw new Error(
        data.description ||
        data.message ||
        String(data.errors || 'Unable to update the cart.')
      );
    }

    return data;
  }

  function sectionIds() {
    const ids = new Set();

    document.querySelectorAll(
      'cart-items-component[data-section-id]'
    ).forEach(component => {
      ids.add(component.dataset.sectionId);
    });

    if (
      document.getElementById('shopify-section-cart-drawer-section')
    ) {
      ids.add('cart-drawer-section');
    }

    return [...ids].filter(Boolean).slice(0, 5);
  }

  function sectionOptions() {
    const ids = sectionIds();

    return ids.length
      ? {
          sections: ids,
          sections_url: window.location.pathname
        }
      : {};
  }

  async function removeProtection(cart, renderSections) {
    const updates = {};

    cart.items.filter(isProtection).forEach(item => {
      updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return cart;

    return request('cart/update.js', {
      updates,
      ...(renderSections ? sectionOptions() : {})
    });
  }

  async function getSections() {
    const ids = sectionIds();

    if (!ids.length) return {};

    const url = new URL(window.location.href);

    url.hash = '';
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', ids.join(','));

    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to refresh the cart display.');
    }

    return response.json();
  }

  async function publishCart(cart, sections) {
    const api = await modulesReady;

    const event = new api.CartLinesUpdateEvent({
      action: 'update',
      context: 'cart',
      lines: [],
      promise: Promise.resolve({
        cart: api.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          source: 'easy-protection',
          sections,
          items: cart.items,
          itemCount: cart.item_count,
          didError: false
        }
      })
    });

    ownedEvents.add(event);
    document.dispatchEvent(event);

    await event.promise;

    schedulePaint();
  }

  async function waitForCartUpdates() {
    while (pendingUpdates.size) {
      await Promise.allSettled([...pendingUpdates]);
    }
  }

  function syncCart(forceSections = false) {
    if (checkingOut) {
      return Promise.resolve(lastCart);
    }

    syncRequested = true;
    sectionsRequested = sectionsRequested || forceSections;

    if (syncPromise) return syncPromise;

    syncPromise = (async () => {
      await modulesReady;

      while (syncRequested && !checkingOut) {
        syncRequested = false;

        const force = sectionsRequested;
        sectionsRequested = false;

        await waitForCartUpdates();

        if (checkingOut) break;

        const version = mutationVersion;
        let cart = await request('cart.js');

        if (checkingOut) break;

        if (version !== mutationVersion) {
          syncRequested = true;
          sectionsRequested = sectionsRequested || force;
          continue;
        }

        lastCart = cart;
        paint();

        const hadProtection = cart.items.some(isProtection);

        if (hadProtection) {
          cart = await removeProtection(cart, true);
        }

        if (checkingOut) break;

        if (version !== mutationVersion) {
          syncRequested = true;
          sectionsRequested = true;
          continue;
        }

        lastCart = cart;

        if (hadProtection || force) {
          const sections = cart.sections || await getSections();

          if (checkingOut) break;

          if (version !== mutationVersion) {
            syncRequested = true;
            sectionsRequested = true;
            continue;
          }

          await publishCart(cart, sections);
        }

        paint();
        clearError();
      }

      return lastCart;
    })().finally(() => {
      syncPromise = null;
      window.easyProtectionCleanupPromise = null;
    });

    window.easyProtectionCleanupPromise = syncPromise;

    return syncPromise;
  }

  function handleCartUpdate(event) {
    if (ownedEvents.has(event)) return;

    mutationVersion++;

    const pending = Promise.resolve(event.promise).catch(error => {
      if (error?.name !== 'AbortError') {
        console.warn('[protection] Cart update failed:', error);
      }
    });

    pendingUpdates.add(pending);

    pending.then(() => {
      pendingUpdates.delete(pending);

      if (!checkingOut) {
        syncCart().catch(reportError);
      }
    });
  }

  function money(cents) {
    if (
      typeof window.Shopify?.formatMoney === 'function' &&
      window.money_format
    ) {
      return window.Shopify
        .formatMoney(cents, window.money_format)
        .replace(/\s*AUD\b/g, '');
    }

    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: lastCart?.currency || 'AUD',
      currencyDisplay: 'narrowSymbol'
    }).format(cents / 100);
  }

  function setMoney(element, cents) {
    const html = money(cents);

    if (element.innerHTML !== html) {
      element.innerHTML = html;
    }

    if (element.tagName === 'TEXT-COMPONENT') {
      const value = element.textContent.trim();

      if (element.getAttribute('value') !== value) {
        element.setAttribute('value', value);
      }
    }
  }

  function paint() {
    document.querySelectorAll(toggleSelector).forEach(input => {
      input.checked = enabled;

      input.closest('.rw-checkbox-span')?.classList.toggle(
        'rw-checked',
        enabled
      );

      if (checkingOut) {
        lockControl(input);
      }
    });

    if (!lastCart) return;

    const items = regularItems(lastCart);

    const count = items.reduce((sum, item) => {
      return sum + item.quantity;
    }, 0);

    const existingFee = lastCart.items
      .filter(isProtection)
      .reduce((sum, item) => {
        return sum + item.final_line_price;
      }, 0);

    const base = Math.max(0, lastCart.total_price - existingFee);
    const protection = quote(lastCart);

    const total = count > 0
      ? base + (enabled ? protection.cents : 0)
      : 0;

    document.querySelectorAll(
      '.insurance-wrapper-main'
    ).forEach(element => {
      if (!count || !protection.eligible) {
        element.hidden = true;
        element.style.setProperty('display', 'none', 'important');
        element.dataset.protectionHidden = 'true';
      } else if (element.dataset.protectionHidden === 'true') {
        element.hidden = false;
        element.style.removeProperty('display');
        delete element.dataset.protectionHidden;
      }
    });

    document.querySelectorAll(
      '#insurancePrice, .insurance-price'
    ).forEach(element => {
      setMoney(element, protection.cents);
    });

    document.querySelectorAll(
      '[data-cart-subtotal], .totals__subtotal-value, .satcb_checkout_price'
    ).forEach(element => {
      setMoney(element, total);
    });

    document.querySelectorAll(
      '[ref="cartBubbleCount"]'
    ).forEach(element => {
      const text = count < 100 ? String(count) : '';

      if (element.textContent !== text) {
        element.textContent = text;
      }

      element.classList.toggle('hidden', count === 0);
    });

    document.querySelectorAll(
      '[ref="cartBubble"]'
    ).forEach(element => {
      element.classList.toggle('visually-hidden', count === 0);
      element.toggleAttribute('data-maintain-ratio', count <= 99);
    });

    document.querySelectorAll('cart-icon').forEach(element => {
      element.classList.toggle(
        'header-actions__cart-icon--has-cart',
        count > 0
      );
    });

    document.querySelectorAll(
      '.theme-drawer__badge'
    ).forEach(element => {
      if (!element.closest('#cart-drawer')) return;

      const text = `${count}\u00a0 ${count <= 1 ? 'item' : 'items'}`;

      if (element.textContent !== text) {
        element.textContent = text;
      }

      element.toggleAttribute('data-maintain-ratio', count <= 99);
    });

    document.querySelectorAll(checkoutSelector).forEach(button => {
      if (checkingOut) {
        lockControl(button);
      } else {
        button.disabled = count === 0;
      }
    });

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({
          value: String(count),
          timestamp: Date.now()
        })
      );
    } catch {}
  }

  function schedulePaint() {
    if (paintScheduled) return;

    paintScheduled = true;

    requestAnimationFrame(() => {
      paintScheduled = false;
      paint();
    });
  }

  function lockControl(element) {
    if (!lockedControls.has(element)) {
      lockedControls.set(element, element.disabled);
    }

    element.disabled = true;
  }

  function unlockControls() {
    lockedControls.forEach((disabled, element) => {
      element.disabled = disabled;
    });

    lockedControls.clear();
  }

  function clearError() {
    document.querySelectorAll(
      '[data-protection-error]'
    ).forEach(element => {
      element.remove();
    });
  }

  function reportError(error) {
    console.error('[protection]', error);

    const host = document.querySelector(
      '#cart-drawer .cart__ctas, .cart__ctas'
    );

    if (!host) return;

    let element = host.querySelector('[data-protection-error]');

    if (!element) {
      element = document.createElement('p');
      element.dataset.protectionError = 'true';
      element.setAttribute('role', 'alert');
      host.prepend(element);
    }

    element.textContent =
      'Unable to update order protection. Please try again before checkout.';
  }

  async function checkoutWithProtection() {
    if (checkingOut) return;

    checkingOut = true;

    const selected = enabled;

    document.querySelectorAll(
      `${checkoutSelector}, ${toggleSelector}`
    ).forEach(lockControl);

    clearError();

    try {
      await modulesReady;

      if (syncPromise) {
        await syncPromise;
      }

      await waitForCartUpdates();

      let cart = await request('cart.js');
      cart = await removeProtection(cart, false);

      lastCart = cart;

      if (!cart.items.length) {
        checkingOut = false;
        unlockControls();

        await syncCart(true);

        return;
      }

      const protection = quote(cart);

      if (selected && protection.eligible) {
        await request('cart/add.js', {
          items: [
            {
              id: Number(protection.variant.id),
              quantity: 1
            }
          ]
        });
      }

      const verified = await request('cart.js');
      const protectionLines = verified.items.filter(isProtection);
      const expected = selected && protection.eligible;

      const correct = expected
        ? protectionLines.length === 1 &&
          protectionLines[0].quantity === 1 &&
          Number(
            protectionLines[0].variant_id ||
            protectionLines[0].id
          ) === Number(protection.variant.id)
        : protectionLines.length === 0;

      if (!correct) {
        throw new Error(
          'Protection did not match the selected option.'
        );
      }

      window.location.assign(`${root}checkout`);
    } catch (error) {
      checkingOut = false;
      unlockControls();

      try {
        await syncCart(true);
      } catch (cleanupError) {
        console.error(
          '[protection] Cleanup failed:',
          cleanupError
        );
      }

      reportError(error);
    }
  }

  document.addEventListener('change', event => {
    if (
      !(event.target instanceof Element) ||
      !event.target.matches(toggleSelector)
    ) {
      return;
    }

    event.stopImmediatePropagation();

    if (checkingOut) {
      paint();
      return;
    }

    savePreference(event.target.checked);
    syncCart().catch(reportError);
  }, true);

  document.addEventListener('click', event => {
    const button = event.target instanceof Element
      ? event.target.closest(checkoutSelector)
      : null;

    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    void checkoutWithProtection();
  }, true);

  document.addEventListener('submit', event => {
    const checkout =
      event.submitter?.matches(checkoutSelector) ||
      (
        !event.submitter &&
        event.target instanceof HTMLFormElement &&
        event.target.id === 'cart-form'
      );

    if (!checkout) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    void checkoutWithProtection();
  }, true);

  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;

    checkingOut = false;
    unlockControls();

    enabled = readPreference();

    paint();
    syncCart(true).catch(reportError);
  });

  window.addEventListener('storage', event => {
    if (event.key !== storageKey || checkingOut) return;

    enabled = readPreference();

    paint();
    syncCart().catch(reportError);
  });

  window.EmraldLabsProtection = {
    version: '3.0.0',

    Init: () => {
      return syncCart().catch(reportError);
    },

    InitWithCart: cart => {
      if (checkingOut) return;

      if (Array.isArray(cart?.items)) {
        lastCart = cart;
        paint();
      }

      return syncCart().catch(reportError);
    },

    Checkproduct: () => {
      return syncCart();
    },

    AddToCard: () => {
      return syncCart();
    },

    CookieInit: () => {
      paint();
    },

    getCookie: name => {
      return name === 'Protectionstatus'
        ? String(enabled)
        : getCookieValues(name)[0] || null;
    },

    getClosests: closestVariant,

    setStatus: value => {
      savePreference(value);
      return syncCart().catch(reportError);
    },

    checkout: checkoutWithProtection
  };

  function initialize() {
    savePreference(enabled);

    const observer = new MutationObserver(records => {
      const relevant = records.some(record => {
        return [...record.addedNodes].some(node => {
          return node instanceof Element && (
            node.matches(
              `${toggleSelector}, .cart-totals, cart-items-component, .cart-drawer__inner`
            ) ||
            node.querySelector(
              `${toggleSelector}, .cart-totals, cart-items-component`
            )
          );
        });
      });

      if (relevant) {
        schedulePaint();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    syncCart().catch(reportError);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();